import React from "react";
import { Button, Form, Input, Select, message, Table } from "antd";
import { useNavigate } from "react-router-dom";
import back_img from "../../../assests/images/rightVector.svg";
import moment from "moment";
import API from "../../../api";
import urls from "../../../api/urls";
import { checkSpace, checkSpecialCharacter } from "../../../utils";
import "./style.scss";

const undeliveredOptions = [
  { label: "UNDELIVERED", value: "UNDELIVERED" },
];

function MarkUndelivered() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [tableData, setTableData] = React.useState([]);

  const columns = [
    {
      title: "AWB Number",
      dataIndex: "awbNumber",
      key: "awbNumber",
      width: 220,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 180,
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      width: 280,
    },
    {
      title: "Marked On",
      dataIndex: "markedOn",
      key: "markedOn",
      width: 220,
    },
  ];

  const onFinish = async (values) => {
    const payload = {
      awbNumber: values.awbNumber,
      reason: values.reason,
    };

    const response = await API.Api(urls.MARK_UNDELIVERED).postIdHeader(payload);

    if (response?.status) {
      message.success(response?.response?.data?.message || `Submitted for AWB ${values.awbNumber}`);
      setTableData((prev) => [
        {
          key: `${values.awbNumber}-${Date.now()}`,
          awbNumber: values.awbNumber,
          status: values.status,
          reason: values.reason,
          markedOn: moment().format("DD-MM-YYYY HH:mm"),
        },
        ...prev,
      ]);
      form.resetFields();
      form.setFieldsValue({ status: "UNDELIVERED" });
      return;
    }

    message.error(response?.response?.data?.message || "Failed to mark undelivered");
  };

  return (
    <div style={{ padding: "20px", background: "#F8FAFC", minHeight: "100vh" }}>
      <div
        style={{
          background: "#fff",
          padding: "16px 24px",
          borderRadius: "8px",
          boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
        }}
      >
        <div style={{ marginBottom: "24px", display: "flex", alignItems: "center" }}>
          <img
            src={back_img}
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer", marginRight: "8px" }}
            alt="back"
          />
          <h1 style={{ margin: 0, fontSize: "20px", fontWeight: "600", color: "#101828" }}>
            Mark Undelivered
          </h1>
        </div>

        <Form form={form} layout="vertical" onFinish={onFinish} className="global-form">
          <div style={{ display: "flex", gap: "12px", alignItems: "flex-start", flexWrap: "wrap" }}>
            <div style={{ width: 260, minHeight: 86 }}>
              <Form.Item
                label="AWB Number"
                name="awbNumber"
                rules={[{ required: true, message: "Please enter the AWB number" }]}
                style={{ marginBottom: 0 }}
              >
                <Input
                  size="large"
                  placeholder="Enter AWB number"
                  style={{ borderRadius: "8px" }}
                  onKeyPress={(e) => {
                    if (checkSpecialCharacter(e) || checkSpace(e)) e.preventDefault();
                  }}
                />
              </Form.Item>
            </div>

            <div style={{ width: 220, minHeight: 86 }}>
              <Form.Item
                label={<span className="mark-undelivered-field-title">Status</span>}
                name="status"
                initialValue="UNDELIVERED"
                rules={[{ message: "Please select status" }]}
                style={{ marginBottom: 0 }}
              >
                <Select
                  size="large"
                  options={undeliveredOptions}
                  disabled
                  style={{
                    borderRadius: "5px",
                  }}
                />
              </Form.Item>
            </div>

          </div>
          <div style={{ marginTop: "10px" }}>
            <Form.Item
              label="Reason"
              name="reason"
              rules={[{ required: true, message: "Please enter the reason" }]}
              style={{ marginBottom: 0, width: "560px", maxWidth: "100%" }}
            >
              <Input.TextArea
                placeholder="Enter reason for marking as undelivered"
                rows={4}
                size="large"
                maxLength={300}
                showCount
                style={{ borderRadius: "8px" }}
              />
            </Form.Item>
          </div>
          <div style={{ marginTop: "12px" }}>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                className="save-btn mark-undelivered-submit-btn"
                style={{ borderRadius: "5px" }}
              >
                Submit
              </Button>
            </Form.Item>
          </div>
        </Form>

        <div style={{ marginTop: "22px" }}>
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={{ pageSize: 10 }}
            locale={{ emptyText: "No undelivered shipment marked yet" }}
            scroll={{ x: 700 }}
          />
        </div>
      </div>
    </div>
  );
}

export default MarkUndelivered;
